import { getLocale } from "../runtime";

const sv_similarproducts = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Liknande produkter`
};

const similarproducts = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_similarproducts(inputs)
	return "similarProducts";
};

export { similarproducts as "similarProducts" };